import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Equipments
 */
class Equipments extends HtmlElement {
    onReady() {
        this.init();
    }

    init() {
        this.$element.owlCarousel({
            items: 1,
            margin: 30,
            nav: true,
            navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
            onInitialized: () => {
                this.setEqualizer();
            },
            responsive: {
                1000: {
                    items: 2
                },
                1500: {
                    items: 3
                }
            }
        });
    }

    setEqualizer() {
        this.$element.find('.owl-stage').attr('data-equalizer', '');
        this.$element.find('.card').each(function() {
            $(this).find('.row').attr('data-equalizer', '');
            //$(this).find('.row').attr('data-equalize-on', 'medium');
            $(this).find('.row .columns').attr('data-equalizer-watch', '');
        });

        new Foundation.Equalizer(this.$element).applyHeight();

        $('[data-equalizer]').addClass('equalized');
    }
}

export default (new Equipments($body.find('.equipments.owl-carousel')));